"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Video360ReferenceSchema = void 0;
exports.Video360ReferenceSchema = {
    "$id": "https://www.redbull.com/schemas/reference/content/videos-360.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "Video360Reference",
    "description": "Video content in 360 degree spherical view.",
    "type": "object",
    "required": [
        "type",
        "id"
    ],
    "properties": {
        "type": {
            "enum": [
                "rrn:master:videos-360"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}$"
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmlkZW9zLTM2MC5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9yZWZlcmVuY2UvY29udGVudC92aWRlb3MtMzYwLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLHVCQUF1QixHQUFHO0lBQ3JDLEtBQUssRUFBRSwwRUFBMEU7SUFDakYsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsbUJBQW1CO0lBQzVCLGFBQWEsRUFBRSw2Q0FBNkM7SUFDNUQsTUFBTSxFQUFFLFFBQVE7SUFDaEIsVUFBVSxFQUFFO1FBQ1YsTUFBTTtRQUNOLElBQUk7S0FDTDtJQUNELFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRTtnQkFDTix1QkFBdUI7YUFDeEI7WUFDRCxNQUFNLEVBQUUsUUFBUTtTQUNqQjtRQUNELElBQUksRUFBRTtZQUNKLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFNBQVMsRUFBRSw2RUFBNkU7U0FDekY7S0FDRjtDQUNGLENBQUEifQ==